import { StyledModal } from '@app/components/modal/Modal';
import useClient from '@app/hooks/users/useClient';
import useUserActions from '@app/hooks/users/useUserActions';
import type { Client } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { ClientForm } from './ClientForm';

export type UserEditModalProps = ModalProps & {
    title?: string;
    data?: Client;
};

export const ClientEditModal = ({
    title = 'Edit Client',
    data,
    onOk,
    ...props
}: UserEditModalProps) => {
    const { editUser } = useUserActions();

    const { data: clientData, isLoading: isClientLoading } = useClient(
        { id: data?.id || '' },
        { enabled: Boolean(props.open) && Boolean(data?.id) }
    );

    return (
        <StyledModal title={title} {...props} footer={null}>
            <ClientForm
                data={clientData}
                isEdit={true}
                onCancel={props.onCancel}
                confirmLoading={editUser.isPending || isClientLoading}
                onSubmit={(values) => {
                    const userId = data?.id?.toString() || '';
                    const { brand_ids, channel_ids, location_ids, ...rest } = values;
                    const formData = {
                        ...rest,
                        id: userId,
                        ...(brand_ids?.length ? { brand_ids } : {}),
                        ...(channel_ids?.length ? { channel_ids } : {}),
                        ...(location_ids?.length ? { location_ids } : {}),
                    };
                    editUser.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
